import { recentSearchDuckCreator } from 'axl-ducks';
import { getPersonalizationClientEnv } from './duckUtils';

const recentSearchDuck = recentSearchDuckCreator({
  ...getPersonalizationClientEnv(),
});
export default recentSearchDuck;
